import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.css']
})
export class SlideshowComponent implements OnInit {
  imageSources = ['../../../../assets/img/1.jpg',
    '../../../../assets/img/2.jpg',
    '../../../../assets/img/3.jpg',
    '../../../../assets/img/4.jpg',
    '../../../../assets/img/5.jpg'
  ];
  // images = ['../../../../assets/img/1.png', '../../../../assets/img/1.png', '../../../../assets/img/1.png'];
  images = ['../../../../assets/img/landing-img.png'];
  constructor(private router: Router) { }

  ngOnInit() {
  }

  login() {
    this.router.navigate(['login']);
  }

}
